import { darken } from 'polished';
import styled from 'styled-components';

import {
  A,
  coreButtonStyles,
  standardFocusStyles,
} from '@main/pc-core-components';
import { responsive, sp } from '@main/theme';

/**
 * The Text Wrapper
 */
export const TextWrapper = styled.h3`
  margin-bottom: ${sp(4.5)};
  text-align: center;
  font-size: ${sp(2.5)};
  font-size: 2vw;
  ${({ theme }) => theme.componentStyles.h3}
  color: ${({ theme }) => theme.colors.textOnAboutTranscend};

  ${responsive.atLeastDesktop} {
    font-size: ${sp(3)};
    font-size: 1.5vw;
  }

  ${responsive.atLeastLargeScreen} {
    font-size: ${sp(3)};
  }
`;

/**
 * Styled A to look like a primary button
 */
export const StyledA = styled(A)`
  ${coreButtonStyles}
  color: ${({ theme }) => theme.colors.textOnPrimary};
  background-color: ${({ theme }) => theme.colors.primary};
  font-family: ${({ theme }) => theme.textStyles.fontFamilyHeader.name};
  padding: 0.8em 1.8em;

  &:hover,
  &:focus {
    opacity: 1;
    color: ${({ theme }) => theme.colors.textOnPrimary};
    background-color: ${({ theme }) => darken(0.1, theme.colors.primary)};
  }

  &:focus {
    ${standardFocusStyles}
  }

  &:active {
    background-color: ${({ theme }) => darken(0.15, theme.colors.primary)};
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ theme }) => theme.componentStyles.primaryButton};
`;

export interface AboutTranscendWidgetWrapperProps {
  /** The provided asset for the widget background */
  asset: string;
}

export const ImageWidget = styled.div<AboutTranscendWidgetWrapperProps>`
  background-color: ${({ theme }) => theme.colors.sidebarNavBg};
  background-image: ${({ asset }) => `url('${asset}')`};
  background-size: 100%;
  background-repeat: no-repeat;
  background-clip: border-box;
  padding: ${sp(5)};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 500px;

  ${responsive.atLeastDesktop} {
    padding: ${sp(6)} ${sp(4.5)};
    height: 600px;
  }
`;

export const DefaultWidget = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.widgetBg};
  padding: ${sp(6)} ${sp(7)} ${sp(7)} ${sp(7)};
`;
